// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2sRsY","content":"LayoutSettings_content__1dA47"};